import { RootState, useAppSelector } from '@Store/store';
import React, { useEffect, useState } from 'react';
import { useLazyGetReferralsQuery } from './apiSlice';
import { displayToast } from '@Utils/toast';
import Loader from '@Components/Loader';

const ReferralPage: React.FC = () => {
  const [getReferral, { data: referralData, error: referralErr, isLoading: isReferralLoading }] = useLazyGetReferralsQuery()

  const [referrals, setReferrals] = useState<any>([])

  const { user } = useAppSelector((state: RootState) => state.profile);
  const referralLink = `https://linkplease.co?af=${user?.user_id}`;
  const [copied, setCopied] = useState(false);


  useEffect(() => {
    getReferral({})
  }, [])

  useEffect(() => {
    if (referralData){
      setReferrals(referralData?.data)
    }

    if (referralErr){
      displayToast('error', referralErr?.message)
    }
  }, [referralData, referralErr])
  
  


  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };


  return (
    <div className=" mx-auto p-6 bg-white shadow-md rounded-xl space-y-4 w-full">
      <h2 className="text-3xl font-medium">Share your unique link</h2>

      <div className="flex flex-col sm:flex-row gap-2 w-1/2">
        <input
          type="text"
          value={referralLink}
          readOnly
          className="border border-gray-300 rounded-lg px-4 py-2 w-3/4"
        />
        <button
          onClick={handleCopy}
          className="bg-[#3535d5] hover:bg-[#3535d5d9] text-white px-4 py-2 rounded-lg w-full sm:w-auto"
        >
          {copied ? 'Copied!' : 'Copy Link'}
        </button>
      </div>

      <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-4 flex items-center space-x-4 w-full">
        <div className="text-yellow-500 text-3xl">💰</div>
        <div>
          <h3 className="text-lg font-semibold">Earn 25% commission</h3>
          <p className="text-sm text-gray-600">
            You get 25% of the revenue from every paid user you refer for the first 11 months.
          </p>
        </div>
      </div>

      {isReferralLoading ? <Loader isLoading={true} /> : <div className="overflow-x-auto w-full">
        <table className="w-full text-left border border-gray-200 rounded-md">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 border-b">Name</th>
              <th className="px-4 py-2 border-b">Is Email Verified</th>
              <th className="px-4 py-2 border-b">Username</th>
            </tr>
          </thead>
          <tbody>
            {referrals.map((ref:any, index:number) => (
              <tr key={index} className="border-t">
                <td className="px-4 py-2">{ref.first_name} {ref.last_name}</td>
                <td className="px-4 py-2">{ref.verified}</td>
                <td className="px-4 py-2">
                  {ref.username ? (
                    <a className='text-blue-600 underline' href={`https://instagram.com/${ref.username}`} target="_blank" rel="noopener noreferrer">
                      @{ref.username}
                    </a>
                  ) : (
                    "Not Connected"
                  )}
              </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>}

      {referrals.length === 0 && (
        <p className="text-center text-gray-500 mt-4">No referrals yet</p>
      )}
    </div>
  );
};

export default ReferralPage;
